import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { Http } from '../../support';
import Loading from '../../facturotopia/loading/Loading';
import ResponseError from '../../shared/responses/ResponseError';

class EmailVerify extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      busy: false
    };
  }

  componentDidMount() {
    const { params = {} } = this.props.match || {};
    const { search = '' } = this.props.location || {};

    this.setState({
      busy: true
    });

    Http.post(`auth/verify/${params.id}/${params.hash}${search}`)
      .then(async (response) => {
        window.ToastManager.show({
          variant: 'success',
          title: 'Completado',
          message: 'Se ha activado tu cuenta exitósamente, inicia sesión.'
        });

        this.setState({
          redirect: true
        });
      }, (error) => {
        this.setState({
          error: error.data || error
        });
      })
      .finally(() => {
        this.setState({
          busy: false
        })
      })
  }

  handleOnAction = (action: string) => {
    this.setState({
      error: undefined,
      redirect: true
    });
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { busy, redirect, error } = this.state;

    if (redirect) {
      const from = { from: { pathname: '/app/dashboard' } };

      return <Redirect to="/bridge" state={ from } />;
    }

    return (
      <>
        <div className="text-center">
          { !!busy && <Loading /> }
          <div>
            { !error && (
              <strong className="text-info">
              Verificando tu cuenta
            </strong>
            )}

            { error && (
              <strong className="text-danger">
                { error.message || 'No podemos verificar tu cuenta, contacta a soporte.' }
              </strong>
            )}
          </div>
        </div>
        { !!error && this.renderError() }
      </>
    );
  }

}

export default EmailVerify;